import { useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Wallet, Loader2 } from "lucide-react";

const PRESETS = [10, 20, 50];

export default function WalletTopupDialog({ open, onOpenChange, onDone }) {
  const [amount, setAmount] = useState(20);
  const [busy, setBusy] = useState(false);
  useEffect(()=>{ if (!open) setBusy(false); }, [open]);

  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/wallet/topup", { amount: Number(amount), origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(formatError(e.response?.data?.detail) || e.message);
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><Wallet className="w-5 h-5 text-emerald-800" />Top up your wallet</DialogTitle>
          <DialogDescription>Prepay for listings — each markdown costs $2 NZD from your balance.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-3 gap-2">
            {PRESETS.map(p => (
              <button key={p} onClick={()=>setAmount(p)} className={`h-12 rounded-lg border font-display font-bold ${Number(amount)===p ? "bg-emerald-800 text-white border-emerald-800" : "bg-white border-slate-200 hover:border-emerald-300"}`} data-testid={`topup-preset-${p}`}>
                ${p}
              </button>
            ))}
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Custom amount (NZD, min $2)</label>
            <Input type="number" min="2" max="500" value={amount} onChange={e=>setAmount(e.target.value)} data-testid="topup-amount" />
          </div>
          <Button onClick={submit} disabled={busy || Number(amount) < 2} className="w-full h-11 bg-emerald-800 hover:bg-emerald-900" data-testid="topup-submit">
            {busy ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" />Redirecting…</> : `Top up $${Number(amount||0).toFixed(2)} NZD`}
          </Button>
          <p className="text-xs text-slate-500 text-center">Secure via Stripe. Test card 4242 4242 4242 4242.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
